<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-11">
<h1>Chapter 11</h1>
<p>Chief Burton’s cellphone rang in his office the following morning after David’s abduction from his friend’s home in the mountains.</p>
<p>“Chief Burton here.”</p>
<p>“Chief Burton, your son is safe,” the voice, calm and deliberate.</p>
<p>“My… Who is this?” asked a startled Burton.</p>
<p>“Call me Number Two,” said the unknown caller.</p>
<p>“Number Two? Is this some kind of joke? What kind of a joke…”</p>
<p>“I assure you this is no joke, it’s for your deniability. Your son’s medical condition is being addressed.”</p>
<p>“I want to speak with him,” demanded Chief Burton.</p>
<p>“We’ll contact you in a few days.”</p>
<p>Chief Burton stared helplessly at his dead cellphone.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch015.vue?2a0e689c